module.exports = __webpack_public_path__ + "img/601-42dfb3.png";